import { Link, useLocation } from 'react-router-dom';

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="relative flex flex-col items-center justify-center min-h-[70vh] text-center px-4 py-20">
      <span className="font-heading font-black text-[7rem] md:text-[11rem] leading-none text-background-200 select-none">
        404
      </span>
      <div className="relative z-10 -mt-6">
        <h1 className="font-heading font-bold text-xl md:text-2xl text-foreground-50">页面不存在</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-sm md:text-base text-foreground-400">这个页面可能已被移除，或链接有误。</p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line"></i>
            返回首页
          </Link>
          <Link
            to="/category/movie"
            className="inline-flex items-center gap-2 h-11 px-6 rounded-md border border-foreground-600 text-foreground-100 text-sm font-semibold hover:bg-background-200/70 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-film-line"></i>
            浏览电影
          </Link>
        </div>
      </div>
    </div>
  );
}